'use strict';

// 문항별 "제출 필수" override — 순수 매핑 헬퍼 (Vue 의존 없음, tests/ 에서 node --test 로 검증)
//
// 캠페인 옵션 '미답변제출차단'(process_options)이 기본값이고,
// sub_data_header.submit_required 에 값이 있으면 그 문항에 한해 캠페인 설정을 덮어쓴다.
// 백엔드와 공유하는 계약값이므로 키/값 문자열을 바꾸지 말 것.
//
// 표시용 '필수답변' 배지(sub_data_header.required_answer)와는 별개 키다.
const SUBMIT_REQUIRED_KEY = 'submit_required';

const SUBMIT_REQUIRED_AUTO = 'auto'; // 캠페인 설정을 따름
const SUBMIT_REQUIRED_ON = 'on';
const SUBMIT_REQUIRED_OFF = 'off';

const SUBMIT_REQUIRED_OPTIONS = [
    { value: SUBMIT_REQUIRED_AUTO, text: '자동(캠페인 설정 따름)' },
    { value: SUBMIT_REQUIRED_ON, text: '켬(항상 필수)' },
    { value: SUBMIT_REQUIRED_OFF, text: '끔(면제)' }
];

// 헤더 → UI 선택값. 'on'/'off' 외의 값(키 없음, null, 오타 등)은 모두 자동으로 본다.
function readSubmitRequired(sub_data_header) {
    const _value = sub_data_header ? sub_data_header[SUBMIT_REQUIRED_KEY] : undefined;
    return _value === SUBMIT_REQUIRED_ON || _value === SUBMIT_REQUIRED_OFF
        ? _value
        : SUBMIT_REQUIRED_AUTO;
}

// UI 선택값 → 헤더. 자동('auto')도 반드시 명시해서 보낸다.
// POST /subs/init 은 화이트리스트 키를 기존 값에 "병합"만 하고 지우지는 않으므로,
// 키를 빼면 서버에 남아 있던 이전 'on'/'off' 가 그대로 유지된다.
function applySubmitRequired(sub_data_header, value) {
    if (!sub_data_header || typeof sub_data_header !== 'object') return sub_data_header;

    sub_data_header[SUBMIT_REQUIRED_KEY] = readSubmitRequired({ [SUBMIT_REQUIRED_KEY]: value });
    return sub_data_header;
}

// 표 문항의 필수 셀 지정 여부. structure[row].required_cells 에 값이 하나라도 있으면 true.
// (백엔드도 같은 기준으로 대상 sub 를 고른다 — 캠페인 옵션이 꺼져 있어도 셀 지정이 있으면 검사 대상)
function hasRequiredCells(structure) {
    return (Array.isArray(structure) ? structure : []).some(_row =>
        !!_row && Array.isArray(_row.required_cells) && _row.required_cells.length > 0
    );
}

// 필수 셀을 켰을 때의 문항 설정 승격 규칙.
// 자동이면 '켬' 으로 올리고, 사용자가 명시한 '켬'/'끔' 은 뒤집지 않는다.
function promoteSubmitRequiredForCell(current) {
    return readSubmitRequired({ [SUBMIT_REQUIRED_KEY]: current }) === SUBMIT_REQUIRED_AUTO
        ? SUBMIT_REQUIRED_ON
        : current;
}

module.exports = {
    SUBMIT_REQUIRED_KEY,
    SUBMIT_REQUIRED_AUTO,
    SUBMIT_REQUIRED_ON,
    SUBMIT_REQUIRED_OFF,
    SUBMIT_REQUIRED_OPTIONS,
    readSubmitRequired,
    applySubmitRequired,
    hasRequiredCells,
    promoteSubmitRequiredForCell
};
